declare const cornerstoneTools: any;
declare const cornerstone: any;

export class HistoricToolDataService {
  private static instance: HistoricToolDataService;

  public lastRemoved: { element: any, toolName: string, data: any } | null = null;

  private constructor() { }

  public static getInstance(): HistoricToolDataService {
    if (!HistoricToolDataService.instance) {
      HistoricToolDataService.instance = new HistoricToolDataService();
    }

    return HistoricToolDataService.instance;
  }

  public setRemoved(element: HTMLElement, toolName: string, data: any) {
    this.lastRemoved = {
      element,
      toolName,
      data
    }
    element.removeEventListener('changedImage', this.removeLastRemoved);
    element.addEventListener('changedImage', this.removeLastRemoved);
  }

  public restoreLastDeletedTool() {
    if (this.lastRemoved != null) {
      cornerstoneTools.addToolState(this.lastRemoved.element, this.lastRemoved.toolName, this.lastRemoved.data);
      cornerstone.updateImage(this.lastRemoved.element);
      this.lastRemoved = null;
    }
  }


  removeLastRemoved: EventListenerOrEventListenerObject = (evt) => this.lastRemoved = null;


}
